function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2043_1273)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M127.505 255.01C197.924 255.01 255.01 197.924 255.01 127.505C255.01 57.0859 197.924 0 127.505 0C57.0859 0 0 57.0859 0 127.505C0 197.924 57.0859 255.01 127.505 255.01Z",
  fill: "#347CFC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.789 147.717H152.78C152.78 150.485 150.542 152.722 147.775 152.722C145.007 152.722 142.77 150.485 142.77 147.727C142.77 147.621 142.77 147.534 142.779 147.437V99.1531H142.77V86.4527C142.77 77.9666 135.894 71.0908 127.408 71.0908C118.922 71.0908 112.046 77.9666 112.046 86.4527V99.3266V147.727H112.036C112.036 150.494 109.799 152.732 107.031 152.732C104.264 152.732 102.027 150.494 102.027 147.727C102.027 147.63 102.027 147.534 102.046 147.437V99.3266H102.027V86.4527C102.027 77.9666 95.1508 71.0908 86.6646 71.0908C78.1785 71.0908 71.3027 77.9666 71.3027 86.4527V148.392C71.3027 168.132 87.3011 184.131 107.041 184.131C114.611 184.131 121.632 181.768 127.418 177.747C133.194 181.768 140.214 184.131 147.794 184.131C167.534 184.131 183.532 168.132 183.532 148.392V111.815H152.799V147.717H152.789Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.513 71.0811H168.151C159.665 71.0811 152.789 77.9568 152.789 86.443V101.805H183.523C192.009 101.805 198.884 94.9291 198.884 86.443C198.884 77.9568 192.009 71.0811 183.523 71.0811H183.513Z",
  fill: "white"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2043_1273"
}, /*#__PURE__*/React.createElement("rect", {
  width: 255,
  height: 255,
  fill: "white"
})));

function SvgWheelplaceSymbol({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 255,
    viewBox: "0 0 255 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelplaceSymbol);
export default __webpack_public_path__ + "static/media/wheelplace-symbol.abd0debc0df58dd5f4b15aa4547a651d.svg";
export { ForwardRef as ReactComponent };